// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useRegistrarServices: () => UseQueryResult<
  TemplateContract<RegistrarService>[],
  string
> = () =>
  useOperatorBasedQuery('queryRegistryRegistrarServices', (ledgerApi, offset, operator) =>
    ledgerApi.queryRegistryRegistrarServices(offset, operator),
  );

export default useRegistrarServices;
